var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgPencilCauze = function SvgPencilCauze(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.732422,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.042 16.4339L8.30064 13.6926M11.042 16.4339L17.1379 10.3083M11.042 16.4339L8.30064 17.2015M8.30064 13.6926L14.4264 7.59656M8.30064 13.6926L7.53306 16.4339M14.4264 7.59656L15.2725 6.75457C15.3513 6.67398 15.4454 6.60995 15.5493 6.56624C15.6532 6.52252 15.7647 6.5 15.8774 6.5C15.9901 6.5 16.1017 6.52252 16.2056 6.56624C16.3095 6.60995 16.4036 6.67398 16.4824 6.75457L17.98 8.26062C18.0593 8.33928 18.1222 8.43286 18.1652 8.53596C18.2081 8.63907 18.2303 8.74966 18.2303 8.86135C18.2303 8.97305 18.2081 9.08364 18.1652 9.18674C18.1222 9.28984 18.0593 9.38342 17.98 9.46208L17.1379 10.3083M14.4264 7.59656L17.1379 10.3083M7.53306 16.4339L7.23456 17.5L8.30064 17.2015M7.53306 16.4339L8.30064 17.2015",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgPencilCauze);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pencil-cauze.5c953091b6626b04c50f6c8a3334a9b3.svg";